<template>
  <div class="if">
    <div class="description">
      <p>合計ポイント、もしくはユーザーの回答ワードによってルートを分岐させます。</p>
    </div>
    <div class="select if_select">
      <select :value="selectItem" @input="updateSelectItem($event.target.value)" :disabled="scenarioEdit.is_confirm">
        <option v-for="(ifItem, i) in ifItems" :key="i" :value="ifItem">
          {{ ifItem }}
        </option>
      </select>
    </div>
    <div  style="display: inline-block; margin: 16px 0px; line-height: 2.5em;" v-if="selectItem === 'ワード'">
      条件とするパーツ：
      <div class="select" style="margin-left: 0;">
        <select :value="scenarioEdit.parameter[0].wordList[0].parts || 0" @input="updatePartsNumber($event.target.value)" :disabled="scenarioEdit.is_confirm">
          <option v-for="(num, i) in wordSelectableNumbers" :key="i" :value="num">
            {{ num || '一つ前' }}
          </option>
        </select>
      </div>
      {{targetPartsInfo}}
    </div>
    <div  style="display: inline-block; margin: 16px 0px; line-height: 2.5em;" v-if="selectItem === '応募者情報'">
      <div v-if="!isRoboPartsSetView">
        条件とする項目：
        <div class="select" style="margin-left: 0;">
          <select :value="scenarioEdit.parameter[0].userInfoList[0].column_pk" @input="updateUserInfoQuotes($event.target.value)" :disabled="scenarioEdit.is_confirm">
            <option v-for="(column, i) in userinfo_quotes" :key="i" :value="column.pk">
              {{ column.name }}
            </option>
          </select>
        </div>
      </div>
      <div v-else style="color: red;">
        <!-- パーツセットにはロボ引用設定が無いため -->
        パーツセット内では応募者情報を使用できません。
      </div>
    </div>
    <div  style="display: inline-block; margin: 16px 0px; line-height: 2.5em;" v-if="selectItem === 'ミニロボ変数'">
      ミニロボ変数名($で囲む必要があります)：
      <div style="display: inline-block; margin-left: 0;">
        <input
          class="input input_word"
          type="text"
          :value="scenarioEdit.parameter[0].miniroboVarsList[0].variable"
          @input="updateMiniroboVariable($event.target.value)"
          :disabled="scenarioEdit.is_confirm"
        />
      </div>
    </div>
    <div v-if="selectItem === ''">
      <div class="select_container disp-scroll"></div>
      <div style="height: 56px"></div>
    </div>
    <div v-if="selectItem === 'ポイント'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px 16px 0px 16px">
          *「以上」の場合はポイントの大きい順、未満の場合はポイントの小さい順に入力してください。
        </p>
        <p style="font-size: 10px; margin: 0px 16px 16px 16px">
          *「リセット」をONにすると、通過後ポイントを0に戻します。
        </p>
        <div v-for="(parameter, index) in scenarioEdit.parameter" :key="index">
          <div class="select_list">
            <span class="patern_num">パターン{{ index + 1 }}:</span>
            <div class="control">
              <input
                class="input input_point"
                type="number"
                :value="parameter.pointList[0].point"
                @input="updatePointListPoint(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              />
            </div>
            <span class="connecting-word">ポイント</span>
            <div class="select">
              <select
                :value="parameter.pointList[0].terms"
                @input="updatePointListTerms(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              >
                <option v-for="(point_patern, i) in point_paterns" :key="i">
                  {{ point_patern }}
                </option>
              </select>
            </div>
            <span class="connecting-word">のとき</span>
            <b-switch
              :value="parameter.pointList[0].reset"
              @input="updatePointListReset(index, $event)"
              style="margin: 0px 0px 0px 32px"
              :disabled="scenarioEdit.is_confirm"
            ></b-switch>
            <span class="connecting-word" style="margin-left: 0px; width: 100px"
              >リセット：{{ parameter.pointList[0].reset ? 'ON' : 'OFF' }}</span
            >
            <div
              class="close-wrapper"
              @click="
                delPattern(index)
                delSelect(index)
              "
              v-if="scenarioEdit.parameter.length > 2"
            >
              <span class="mdi mdi-close"></span>
            </div>
          </div>
        </div>
      </div>
      <p style="font-size: 13px; padding: 10px">
        <button
          v-if="scenarioEdit.parameter.length < 10"
          class="button is-fullwidth"
          @click="
            addPattern()
            addSelect()
            updatePartsNumber()
          "
          :disabled="scenarioEdit.is_confirm"
        >
          <i class="mdi mdi-plus-box"></i>パターンを増やす
        </button>
      </p>
      <div v-if="scenarioEdit.parameter.length >= 10" style="height: 36px"></div>
    </div>
    <div v-if="selectItem === 'ワード'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px">
          *パターン1から順に判定して、最初に条件が一致したパターンが選択されます。
        </p>
        <div v-for="(parameter, index) in scenarioEdit.parameter" :key="index">
          <div class="select_list">
            <span class="patern_num">パターン{{ index + 1 }}:</span>
            <span class="connecting-word">回答ワードが</span>
            <div class="control">
              <input
                class="input input_word"
                type="text"
                :value="parameter.wordList[0].word"
                @input="updateWordListWord(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              />
            </div>
            <span class="connecting-word">と</span>
            <div class="select">
              <select
                :value="parameter.wordList[0].terms"
                @input="updateWordListTerms(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              >
                <option v-for="(word_patern, i) in word_paterns" :key="i">{{ word_patern }}</option>
              </select>
            </div>
            <span class="connecting-word">とき</span>
            <div
              class="close-wrapper"
              @click="
                delPattern(index)
                delSelect(index)
              "
              v-if="scenarioEdit.parameter.length > 2"
            >
              <span class="mdi mdi-close"></span>
            </div>
          </div>
        </div>
      </div>
      <p style="font-size: 13px; padding: 10px">
        <button
          v-if="scenarioEdit.parameter.length < 10"
          class="button is-fullwidth"
          @click="
            addPattern()
            addSelect()
            updatePartsNumber()
          "
          :disabled="scenarioEdit.is_confirm"
        >
          <i class="mdi mdi-plus-box"></i>パターンを増やす
        </button>
      </p>
      <div v-if="scenarioEdit.parameter.length >= 10" style="height: 36px"></div>
    </div>
    <div v-if="selectItem === '応募者情報'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px">
          *パターン1から順に判定して、最初に条件が一致したパターンが選択されます。
        </p>
        <div v-for="(parameter, index) in scenarioEdit.parameter" :key="index">
          <div class="select_list">
            <span class="patern_num">パターン{{ index + 1 }}:</span>
            <span class="connecting-word">応募者情報が</span>
            <div class="control">
              <input
                class="input input_word"
                type="text"
                :value="parameter.userInfoList[0].word"
                @input="updateUserInfoListWord(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              />
            </div>
            <span class="connecting-word">と</span>
            <div class="select">
              <select
                :value="parameter.userInfoList[0].terms"
                @input="updateUserInfoListTerms(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              >
                <option v-for="(word_patern, i) in userinfo_patterns" :key="i">{{ word_patern }}</option>
              </select>
            </div>
            <span class="connecting-word">とき</span>
            <div
              class="close-wrapper"
              @click="
                delPattern(index)
                delSelect(index)
              "
              v-if="scenarioEdit.parameter.length > 2"
            >
              <span class="mdi mdi-close"></span>
            </div>
          </div>
        </div>
      </div>
      <p style="font-size: 13px; padding: 10px">
        <button
          v-if="scenarioEdit.parameter.length < 10"
          class="button is-fullwidth"
          @click="
            addPattern()
            addSelect()
            updatePartsNumber()
          "
          :disabled="scenarioEdit.is_confirm"
        >
          <i class="mdi mdi-plus-box"></i>パターンを増やす
        </button>
      </p>
      <div v-if="scenarioEdit.parameter.length >= 10" style="height: 36px"></div>
    </div>
    <div v-if="selectItem === 'ミニロボ変数'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px">
          *パターン1から順に判定して、最初に条件が一致したパターンが選択されます。
        </p>
        <div v-for="(parameter, index) in scenarioEdit.parameter" :key="index">
          <div class="select_list">
            <span class="patern_num">パターン{{ index + 1 }}:</span>
            <span class="connecting-word">変数の値が</span>
            <div class="control">
              <input
                class="input input_word"
                type="text"
                :value="parameter.miniroboVarsList[0].word"
                @input="updateMiniroboVarsListWord(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              />
            </div>
            <span class="connecting-word">と</span>
            <div class="select">
              <select
                :value="parameter.miniroboVarsList[0].terms"
                @input="updateMiniroboVarsListTerms(index, $event.target.value)"
                :disabled="scenarioEdit.is_confirm"
              >
                <option v-for="(word_patern, i) in minirobo_patterns" :key="i">{{ word_patern }}</option>
              </select>
            </div>
            <span class="connecting-word">とき</span>
            <div
              class="close-wrapper"
              @click="
                delPattern(index)
                delSelect(index)
              "
              v-if="scenarioEdit.parameter.length > 2"
            >
              <span class="mdi mdi-close"></span>
            </div>
          </div>
        </div>
      </div>
      <p style="font-size: 13px; padding: 10px">
        <button
          v-if="scenarioEdit.parameter.length < 10"
          class="button is-fullwidth"
          @click="
            addPattern()
            addSelect()
            updatePartsNumber()
          "
          :disabled="scenarioEdit.is_confirm"
        >
          <i class="mdi mdi-plus-box"></i>パターンを増やす
        </button>
      </p>
      <div v-if="scenarioEdit.parameter.length >= 10" style="height: 36px"></div>
    </div>
    <div v-if="selectItem === 'ランダム'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px">*ランダムに選ばれたパターンが選択されます。</p>
        <div v-for="(parameter, index) in scenarioEdit.parameter" :key="index">
          <div class="select_list">
            <span class="patern_num">パターン{{ index + 1 }}:</span>
            <span class="connecting-word"
              >1 / {{ scenarioEdit.parameter.length }} の確率で選択されます</span
            >
            <div
              class="close-wrapper"
              @click="
                delPattern(index)
                delSelect(index)
              "
              v-if="scenarioEdit.parameter.length > 2"
            >
              <span class="mdi mdi-close"></span>
            </div>
          </div>
        </div>
      </div>
      <p style="font-size: 13px; padding: 10px">
        <button
          v-if="scenarioEdit.parameter.length < 10"
          class="button is-fullwidth"
          @click="
            addPattern()
            addSelect()
            updatePartsNumber()
          "
          :disabled="scenarioEdit.is_confirm"
        >
          <i class="mdi mdi-plus-box"></i>パターンを増やす
        </button>
      </p>
      <div v-if="scenarioEdit.parameter.length >= 10" style="height: 36px"></div>
    </div>
    <div v-if="selectItem === 'セッション切替'">
      <div class="select_container disp-scroll">
        <p style="font-size: 10px; margin: 16px">
          *この分岐パーツを通過すると新しいセッションが開始されます。<br>
          選択肢パーツの特定の選択肢を選んだルートにこの分岐パーツを配置することで、セッション切替を制御します。
        </p>
        <div style="padding: 20px; background: #f5f5f5; margin: 16px; border-radius: 4px;">
          <h4 style="margin-bottom: 10px;">使い方の例:</h4>
          <p style="font-size: 12px; line-height: 1.6;">
            選択肢パーツAの選択肢a → 分岐パーツ（セッション切替） → 後方ルート<br>
            選択肢パーツAの選択肢b → 後方ルート（分岐パーツを通らない）<br><br>
            上記の構成により、選択肢aを選んだ場合はセッションが切り替わり、<br>
            選択肢bを選んだ場合は同一セッションが継続されます。
          </p>
        </div>
        
        <!-- 分岐先が1つであることを明示 -->
        <div style="margin: 16px; padding: 10px; background: #e3f2fd; border-radius: 4px;">
          <p style="font-size: 11px; color: #1976d2; margin: 0;">
            <i class="mdi mdi-information"></i> セッション切替後は1つの分岐先に進みます
          </p>
        </div>
        
        <p style="font-size: 11px; margin: 16px; color: #666;">
          ※詳細設定はありません。この分岐パーツを通過するだけで新しいセッションが開始されます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    selectItem: {
      type: String,
      required: true,
    },
    ifItems: {
      type: Array,
      required: true,
    },
    scenarioEdit: {
      type: Object,
      required: true,
    },
    delPattern: {
      type: Function,
      required: true,
    },
    delSelect: {
      type: Function,
      required: true,
    },
    addPattern: {
      type: Function,
      required: true,
    },
    addSelect: {
      type: Function,
      required: true,
    },
    point_paterns: {
      type: Array,
      required: true,
    },
    word_paterns: {
      type: Array,
      required: true,
    },
    displayQuoteMsg: {
      type: Function,
      required: true
    },
    userinfo_quotes: {
      type: Array,
      required: true
    },
    userinfo_patterns: {
      type: Array,
      required: true
    },
    minirobo_patterns: {
      type: Array,
      required: true
    },
    isRoboPartsSetView: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    // 応募者情報のパラメータがない場合は生成
    this.scenarioEdit.parameter.forEach(param => {
      if (!param.userInfoList) {
        this.$set(param, 'userInfoList', [
          {
            word: '',
            terms: '',
            column_pk: -1,
          },
        ]);
      }
      if (!param.miniroboVarsList) {
        this.$set(param, 'miniroboVarsList', [
          {
            word: '',
            terms: '',
            variable: '',
          },
        ]);
      }
    });
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable']),
    wordSelectableNumbers () {
      let ary = this.scenarioTable.filter(scenario => [0,1,4,6,8,13,15].includes(scenario.status)).map(scenario => scenario.pk)
      ary = [0].concat(ary)
      return ary
    },
    targetPartsInfo () {
      if (!this.scenarioEdit.parameter[0].wordList[0].parts) return ''
      let target = this.scenarioTable.find(scenario => scenario.pk == this.scenarioEdit.parameter[0].wordList[0].parts)
      if (!target) return ''
      return '(' + this.displayQuoteMsg(target.mainmessage) + ')'
    },
  },
  methods: {
    updatePartsNumber(num) {
      let partsNumber = (num || this.scenarioEdit.parameter[0].wordList[0].parts || 0)
      this.$emit('update-word-parts-number', partsNumber)
    },
    updateUserInfoQuotes(column) {
      this.$emit('update-user-info-quotes', column)
    },
    updateMiniroboVariable(value) {
      this.$emit('update-minirobo-variable', value)
    },
    updateSelectItem(value) {
      this.$emit('update-select-item', value)
    },
    updatePointListPoint(i, value) {
      this.$emit('update-point-list-point', i, value)
    },
    updatePointListTerms(i, value) {
      this.$emit('update-point-list-terms', i, value)
    },
    updatePointListReset(i, value) {
      this.$emit('update-point-list-reset', i, value)
    },
    updateWordListWord(i, value) {
      this.$emit('update-word-list-word', i, value)
    },
    updateWordListTerms(i, value) {
      this.$emit('update-word-list-terms', i, value)
    },
    updateUserInfoListWord(i, value) {
      this.$emit('update-user-info-word', i, value)
    },
    updateUserInfoListTerms(i, value) {
      this.$emit('update-user-info-terms', i, value)
    },
    updateMiniroboVarsListWord(i, value) {
      this.$emit('update-minirobo-word', i, value)
    },
    updateMiniroboVarsListTerms(i, value) {
      this.$emit('update-minirobo-terms', i, value)
    },
  },
}
</script>

<style scoped lang="scss">
.if {
  .description {
    font-size: 14px;
  }
  &_select {
    margin: 16px;
  }
  .select {
    &_container {
      height: 272px;
      border: 1px solid #dbdbdb;
      margin-bottom: 6px;
      border-radius: 3px;
    }
    &_list {
      margin: 16px 0 16px 32px;
      display: flex;
      align-items: center;
    }
  }
  .patern_num {
    font-size: 14px;
    font-weight: bold;
    margin-right: 16px;
  }
  .input_point {
    width: 64px;
  }
  .connecting-word {
    font-size: 14px;
    margin: 6px;
  }
  .close-wrapper {
    cursor: pointer;
    font-weight: bold;
    opacity: 0.6;
    margin-left: 16px;
    &:hover {
      opacity: 1;
      color: red;
    }
    .mdi-close {
      &:before {
        font-weight: bold;
      }
    }
  }

  /* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  input::-ms-clear {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditIf.vue